import { gql } from "@apollo/client";
import { SEARCH_ITEM_FIELDS } from "../fragments/searchItem";

const me = gql`
  ${SEARCH_ITEM_FIELDS}
  query Me {
    me {
      id
      name
      privateInfo {
        email
        accessToken
        isPartner
        createdAt
        collections {
          id
          name
          totalCount
          items {
            ...SEARCH_ITEM_FIELDS
          }
        }
      }
    }
    featureFlags {
      showPreferencePopup
      showPreferenceBanner
    }
    isPreferenceSet
  }
`;
export default me;
